var exports = {
  "wj": "CardFrame__1Wp4YM",
  "fG": "DraggedCard__OxZ-2v",
  "Vx": "CardLanded__0kzu9S",
  "CX": "CardLandedForcedColors__fwqxZH",
};

module.exports = exports;
